import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';
import {
  IGroupTutorRateCourseType,
  IGroupTutorRateCourseTypeDeleteVerificationData,
} from '.';

export type TAdminCreateGroupTutorRateCourseType = {
  name: string;
  grades: Array<{ curriculum: string; grade: string }>;
};

export type TAdminGetGroupTutorRateCourseTypes = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateGroupTutorRateCourseType = {
  id: string;
  name: string;
  grades: Array<{ curriculum: string; grade: string }>;
};

const apiDataProvider = new APIDataProvider();

const adminGetGroupTutorRateCourseTypesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetGroupTutorRateCourseTypes) => {
  let path = `${AdminApiPaths.groupTutorRateCourseTypes}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IGroupTutorRateCourseType>>
  >(path);

  return response.data;
};

export const adminCreateGroupTutorRateCourseType = createAsyncThunk(
  '/admin/group-tutor-rate-course-types/create',
  async (data: TAdminCreateGroupTutorRateCourseType) => {
    const path = `${AdminApiPaths.groupTutorRateCourseTypes}`;

    const response = await apiDataProvider.post<
      TApiResponse<IGroupTutorRateCourseType>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateGroupTutorRateCourseType = createAsyncThunk(
  '/admin/group-tutor-rate-course-types/update',
  async (data: TAdminUpdateGroupTutorRateCourseType) => {
    const path = `${AdminApiPaths.groupTutorRateCourseTypes}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IGroupTutorRateCourseType>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteGroupTutorRateCourseType = createAsyncThunk(
  '/admin/group-tutor-rate-course-types/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.groupTutorRateCourseTypes}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IGroupTutorRateCourseType>
    >(path);

    return response.data;
  }
);

export const adminVerifyGroupTutorRateCourseTypeDelete = createAsyncThunk(
  '/admin/group-tutor-rate-course-types/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.groupTutorRateCourseTypes}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IGroupTutorRateCourseTypeDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetGroupTutorRateCourseTypes = createAsyncThunk(
  '/admin/group-tutor-rate-course-types/list',
  adminGetGroupTutorRateCourseTypesModule
);

export const adminGetGroupTutorRateCourseTypesForDropdown = createAsyncThunk(
  '/admin/group-tutor-rate-course-types/dropdown-list',
  adminGetGroupTutorRateCourseTypesModule
);
